var React = require('react');

function DisplayTag (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"49.625","height":"36.125","x":".5","y":".5","stroke":"#ffdb00","rx":"1.5","key":0}),React.createElement("path",{"stroke":"#ffdb00","d":"M0 30h50.625M19.125 37.125V45m13.5 0v-7.875M9 45h32.625M28 9l-5 13.5M31 22.5l6-6.5-6-7M20 22.5L14 16l6-7","key":1})]);
}

DisplayTag.defaultProps = {"fill":"none","viewBox":"0 0 51 46"};

module.exports = DisplayTag;

DisplayTag.default = DisplayTag;
